module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai19-a8d7bc1cd7cb2a3520e9ddd731b0c71b.jpg";